/* eslint-disable relay/unused-fields */
import { graphql } from 'babel-plugin-relay/macro'
import { useLazyLoadQuery } from 'react-relay-offline'

import type {
  useSalesAssociatesOrderFormQuery,
  useSalesAssociatesOrderFormQuery$variables,
} from './__generated__/useSalesAssociatesOrderFormQuery.graphql'

const SALES_ASSOCIATES_ORDERFORM_QUERY = graphql`
  query useSalesAssociatesOrderFormQuery(
    $where: SalesAssociatesOrderFormsWhere
  ) {
    salesAssociatesOrderForms(where: $where) {
      edges {
        node {
          id
          updatedIn
          cartTotal
          code
          customerIdentification
          customerName
          numberOfItems
          orderFormId
          orderGroupId
          status
          vendor
          vendorLinked {
            id
            name
            user
            code
            store
            storeLinked {
              id
              country
              name
              tradePolicy
              address
              number
              neighborhood
              city
              state
              postalCode
              mobileNumber
              pickupPoint
              franchiseAccount
              inactivatedAt
            }
          }
          createdIn
        }
      }
    }
  }
`

export const useSalesAssociatesOrderForm = (
  variables: useSalesAssociatesOrderFormQuery$variables
) => {
  const {
    data: salesAssociatesOrderFormData,
    error: salesAssociatesOrderFormError,
  } = useLazyLoadQuery<useSalesAssociatesOrderFormQuery>(
    SALES_ASSOCIATES_ORDERFORM_QUERY,
    variables,
    {
      fetchPolicy: 'store-and-network',
    }
  )

  return {
    salesAssociatesOrderFormData,
    salesAssociatesOrderFormError,
  }
}
